import { StyleSheet } from 'react-native';

/**
 * CORE-311 — the message menu on a phone-width web viewport. The reactions ran
 * in one line wider than the screen, and an own message's menu, pinned to the
 * right, pushed its left half off the edge. A fixed width that holds six
 * reactions per line (34px each, 4px gaps, 8px side padding) keeps the card on
 * screen next to either side's bubble; the rest wrap to a second line.
 *
 * The card floats over the messages there (MessageMenuLayer), so the thread
 * pairs it with the opaque `surfaceDialog` — the translucent `surfaceElevated`
 * let the text underneath show through.
 */
export const messageMenuMobileStyles = StyleSheet.create({
  // No margins: MessageMenuLayer places the card against the «…» itself.
  card: { width: 248, marginTop: 0, marginHorizontal: 0 },
  picker: { flexWrap: 'wrap', rowGap: 4 },
});
